<template>
  <div>
    <div class="header">
      <div class="layui-container">
        <div class="nav-right">
          <span class="login-btn">第一次使用六六钢铁？<a href="/#/register">立即注册</a></span>
        </div>
        <a class="logo"
           href=""></a>
      </div>
    </div>
    <div class="layui-col-xs12 layui-col-md12 layui-tab-height"
         style="background-color: #16469e;background-image: linear-gradient(to left, rgb(0, 192, 243), rgb(92, 159, 247) 60%, rgb(22, 70, 158) 80%); ">
      <div class="layui-container">
        <div class="layui-col-xs6 layui-col-md8 mb mt">
          <img src="../assets/images/bglogin.png"
               width="750">
        </div>
        <div class="layui-col-xs6 layui-col-md4 mb mt">
          <div class="login-link">
            <div class="layui-tab layui-tab-brief"
                 lay-filter="docDemoTabBrief">
              <ul class="layui-tab-title">
                <li class="layui-this">登录</li>
              </ul>
            </div>
            <div class="layui-tab-content">
              <div class="layui-tab-item layui-show"
                   style="margin-top:25px;">
                <el-form ref="login-form"
                         :model="user"
                         :rules="formRules">
                  <el-form-item prop="account">
                    <el-input v-model="user.account"
                              placeholder="请输入手机号或邮箱"
                              prefix-icon="el-icon-user"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="user.password"
                              show-password
                              placeholder="请输入密码"
                              prefix-icon="el-icon-lock"></el-input>
                  </el-form-item>
                  <el-form-item prop="code">
                    <el-input class="code"
                              v-model="user.code"
                              placeholder="请输入验证码"
                              prefix-icon="el-icon-key"></el-input>

                    <div class="codebutton"
                         @click="refreshCode">
                      <s-identify :identifyCode="identifyCode"></s-identify>
                    </div>
                  </el-form-item>

                  <el-form-item>

                    <el-button class="login-btn"
                               type="primary"
                               :loading="loginLoading"
                               @click="onLogin">登录</el-button>
                  </el-form-item>
                  <el-form-item class="forget">
                    <el-link type="primary"
                             :underline="false"><a href="/#/findpassword"
                         class="font-link">忘记密码？</a></el-link>

                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layui-col-md12 layui-col-xs12 containers">
      <div class="layui-container">
        <div class="copyright-box">
          <div id="csdn-copyright-footer"
               class="column dark">
            <ul class="footer-column-t">
              <li>
                <img src="../assets/images/tel.png"
                     alt="">
                <span> 020-83887466-8056</span>
              </li>
              <li>
                <img src="../assets/images/email.png"
                     alt="">
                <a href="mailto:gzgwzg@yeah.net"
                   target="_blank"> gzgwzg@yeah.net</a>
              </li>
              <li>
                工作时间&nbsp;9:00-17:30
              </li>
              <li>
                <a href="javascript:;"
                   @click="about"> 关于我们</a>
              </li>
            </ul>
            <ul class="footer-column-b">
              <li><img src="../assets/images/beian.png"
                     alt=""><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402002322"
                   rel="noreferrer"
                   target="_blank">粤公网安备 44010402002322号</a></li>
              <li><a href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
                   rel="noreferrer"
                   target="_blank">粤ICP备17117697号-2</a></li>
              <li>©2016-2024 智钢数据服务（广州）有限公司</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="关于我们"
               append-to-body
               :visible.sync="dialogTableVisible">
      <div class="about"> 智钢数据服务（广州）有限公司（简称：智钢），2018年成立于中国国际商贸中心——广州。基于母公司八年的行业经验，乘着“互联网+”的时代浪潮，为传统钢铁行业转型升级贡献一份力量。
        智钢致力于打造华南地区钢铁行业的专业服务平台。旗下目前主打产品有“六六钢铁”和“一拍即点”，六六钢铁——以真实交易数据构建华南现货价格体系，利用大数据提供交易、仓储、物流全方位数据服务，为用户提供高效、安全、透明的钢铁在线交易平台；一拍即点——引入AI智能识别技术代替人工数钢筋，用数字技术提升工地整体精细化管理水平。通过互联网真正实现钢铁行业上下游信息化、数据化、智能化的转型升级。</div>
    </el-dialog>
  </div>
</template>

<script>
// import JcRange from '@/components/JcRange.vue'
import SIdentify from '@/components/identify'
import { login } from '@/api/user'
export default {
  name: 'Login',
  data () {
    const validateCode = (rule, value, callback) => {
      // console.log(value)
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (value !== this.identifyCode) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    return {
      codestatus: false,
      user: {
        account: '',
        password: '',
        code: ''
      },
      makeCode: '',
      identifyCode: '',
      accuracy: 1,
      loginLoading: false,
      dialogTableVisible: false,
      formRules: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3|5|6|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    's-identify': SIdentify
  },
  mounted () {
    // 绑定事件
    window.addEventListener('keydown', this.keyDown)
    this.makeIdentifyCode({ typeMix: false, pureNumber: 'number' })
  },
  methods: {
    onLogin () {
      this.$refs['login-form'].validate(valid => {
        if (!valid) {
          return false
        }
        this.login()
      })
    },
    login () {
      this.loginLoading = true
      login(this.user).then(res => {
        if (res.data.status === 'success') {
          this.loginLoading = false
          window.localStorage.setItem('user', JSON.stringify(res.data))
          if (res.data.power === 2) {
            // 跳转到工程页面
            this.$router.push({
              name: 'Engineer'
            })
          } else {
            // 跳转到首页
            this.$router.push({
              name: 'Index'
            })
          }
        } else {
          this.$message.error(res.data.message)
          this.loginLoading = false
        }
      }).catch(err => {
        console.log('登录失败', err)
        // this.$message.error('登录失败，手机号或密码错误')
        this.loginLoading = false
      })
    },
    cedesuccess () {
      this.user.code = this.createCode()
    },
    cedeerror () {
      this.user.code = ''
    },
    createCode () {
      var code = ''
      var codeLength = 4
      var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      for (var i = 0; i < codeLength; i++) {
        var index = Math.floor(Math.random() * 9)
        code += random[index]
      }
      return code
    },
    keyDown (e) {
      // 如果是回车则执行登录方法
      if (e.keyCode === 13) {
        this.onLogin()
      }
    },
    about () {
      this.dialogTableVisible = true
    },
    /**
     * 随机生成一个0~9之间的数
     */
    randomNum () {
      return Math.floor(Math.random() * 10)
    },

    /**
     * 随机生成一个字母
     * @param {boolean} isUupper 生成大写字母
     */
    randomAlphabet ({ isUupper = false } = {}) {
      // a的Unicode值为97,z的Unicode值为123
      const alphabet = String.fromCharCode(Math.floor(Math.random() * 25) + 97)
      if (!isUupper) {
        return alphabet
      } else {
        return alphabet.toUpperCase()
      }
    },

    /**
     * 生成图片验证码
     * @param {number} length 图片验证码位数
     * @param {boolean} typeMix 数字和字母混合
     * @param {string} pureNumber 纯数字('number')或者字母('alphabet')
     * @param {boolean} randomTypeLen 随机生成类型个数组合
     * @param {boolean} capsLookMix 字母大小写混合
     * @param {number} numLength 混合类型下的数字个数
     * @param {number} uupperLength 大写字母的个数
     */
    makeIdentifyCode ({ length = 4, typeMix = true, pureNumber = 'alphabet', randomTypeLen = false, capsLookMix = false, numLength = 2, uupperLength = 1 } = {}) {
      this.makeCode = ''
      // 数字和字母混合
      if (typeMix) {
        // 随机生成类型个数组合
        if (randomTypeLen) {
          // 字母大小写混合
          if (capsLookMix) {
            const numLength = Math.floor(Math.random() * length) + 1
            const uupperLength = numLength === length ? 0 : Math.floor(Math.random() * (length - numLength)) + 1
            for (let i = 0; i < numLength; i++) {
              this.makeCode += this.randomNum()
            }
            for (let i = 0; i < uupperLength; i++) {
              this.makeCode += this.randomAlphabet({ isUupper: true })
            }
            if (numLength + uupperLength < length) {
              for (let i = 0; i < length - numLength - uupperLength; i++) {
                this.makeCode += this.randomAlphabet()
              }
            }
          } else {
            const numLength = Math.floor(Math.random() * length) + 1
            for (let i = 0; i < numLength; i++) {
              this.makeCode += this.randomNum()
            }
            if (numLength < length) {
              for (let i = 0; i < length - numLength; i++) {
                this.makeCode += this.randomAlphabet()
              }
            }
          }
        } else {
          // 字母大小写混合
          if (capsLookMix) {
            const tempNumLength = numLength < 0 ? 2 : numLength > length ? 2 : numLength
            const tempUupperLength = uupperLength < 0 ? 1 : uupperLength > length - tempNumLength ? 1 : uupperLength
            for (let i = 0; i < tempNumLength; i++) {
              this.makeCode += this.randomNum()
            }
            for (let i = 0; i < tempUupperLength; i++) {
              this.makeCode += this.randomAlphabet({ isUupper: true })
            }
            if (tempNumLength + tempUupperLength < length) {
              for (let i = 0; i < length - tempNumLength - tempUupperLength; i++) {
                this.makeCode += this.randomAlphabet()
              }
            }
          } else {
            const tempNumLength = numLength < 0 ? 2 : numLength > length ? 2 : numLength
            for (let i = 0; i < tempNumLength; i++) {
              this.makeCode += this.randomNum()
            }
            if (tempNumLength < length) {
              for (let i = 0; i < length - tempNumLength; i++) {
                this.makeCode += this.randomAlphabet()
              }
            }
          }
        }
      } else {
        // 纯数字('number')
        if (pureNumber === 'number') {
          for (let i = 0; i < length; i++) {
            this.makeCode += this.randomNum()
          }
        }
        // 纯字母('alphabet')
        if (pureNumber === 'alphabet') {
          // 字母大小写混合
          if (capsLookMix) {
            const tempUupperLength = uupperLength < 0 ? 1 : uupperLength > length ? 1 : uupperLength
            for (let i = 0; i < tempUupperLength; i++) {
              this.makeCode += this.randomAlphabet({ isUupper: true })
            }
            if (tempUupperLength < length) {
              for (let i = 0; i < length - tempUupperLength; i++) {
                this.makeCode += this.randomAlphabet()
              }
            }
          } else {
            for (let i = 0; i < length; i++) {
              this.makeCode += this.randomAlphabet()
            }
          }
        }
      }
      this.shuffle(this.makeCode)
    },

    /**
     * 图片验证码随机排序
     * @param {string} str 图片验证码
     */
    shuffle (str) {
      this.identifyCode = [...str].sort(() => Math.random() - 0.5).join('')
    },

    /**
     * 更换图片验证码
     */
    refreshCode () {
      this.makeIdentifyCode({ typeMix: false, pureNumber: 'number' })
    }
  }
}
</script>

<style lang="less" scoped>
.containers {
  width: 100%;
  height: 100%;
}
.layui-container {
  max-width: 1440px;
}
.layui-tab-content {
  padding: 0px;
}
.layui-tab-height {
  min-height: 708px;
}
.mb {
  margin-bottom: 60px;
}
.mt {
  margin-top: 60px;
}
.el-button {
  width: 100%;
}
.el-form-item {
  margin-bottom: 32px;
}
.forget {
  width: 100px;
  margin-top: -20px;
}
.font-link {
  color: #1e9fff;
}
.copyright-box {
  width: 100%;
  margin-top: 15px;
}
.column {
  margin: 0 auto;
  padding: 24px 34px 20px;
}
.column .footer-column-t {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.column .footer-column-t li {
  margin: 0 8px;
  color: #999aaa;
  font-size: 14px;
  height: 16px;
  line-height: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.column a {
  text-decoration: none;
  color: inherit;
}
.column .footer-column-b {
  margin-top: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.column .footer-column-b li {
  font-size: 12px;
  color: #999aaa;
  height: 16px;
  line-height: 16px;
  margin: 4px 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.column .footer-column-b li img {
  width: 14px;
  height: 14px;
  display: block;
  margin-right: 4px;
}
.about {
  font-size: 16px;
  line-height: 28px;
  text-indent: 2em;
}
.code {
  width: 60%;
  float: left;
}
.codebutton {
  width: 35%;
  float: left;
  margin-left: 5%;
}
</style>
